import React, { useRef, useState } from 'react';
import { Card, CreditDetails, MultiSelectView } from '../common';
import {
  Textarea,
  RadioGroup,
  Heading,
  SubHeading,
  CheckboxList,
} from '../../../../../UiKit';
import {
  getFormData,
  checkIfOptional,
} from '../../../../commons/CommonMethods';

export default function DelightCreditsBlinkit({
  issueInfo,
  orderId,
  reasonId,
  creditOptions,
  sendFormData,
  getCreditOptions,
  isDisabled,
  handleCardLink,
}) {
  const [showCredit, setShowCredit] = useState();
  const creditsbodyParams = useRef(null);

  const selectCheckboxOptions = (selectedOptions) => {
    setShowCredit(false);
    selectedOptions.length &&
      fetchCreditOptions(issueInfo?.check_box, selectedOptions);
  };

  const selectRadioOption = (selectedOption) => {
    setShowCredit(false);
    fetchCreditOptions(issueInfo?.radio, selectedOption);
  };

  const fetchCreditOptions = (comp, selectedOption) => {
    const url = comp?.url;
    if (!url) return;

    let compData = getFormData(comp, selectedOption);

    let data = {
      order_id: orderId,
      support_option: 'refund',
      ...compData,
    };
    creditsbodyParams.current = data;

    setShowCredit(true);
    getCreditOptions(url, reasonId, data);
  };

  const submitForm = (urlStr, params) => {
    const { submit_button } = issueInfo;
    let url = urlStr ? urlStr : submit_button.url;

    const finalData = { order_id: orderId, ...params };

    sendFormData(url, reasonId, finalData);
  };

  const credit_details_comp =
    showCredit && creditOptions ? (
      <div className='pt10'>
        <CreditDetails
          creditOptions={creditOptions}
          sendFormData={submitForm}
          orderId={orderId}
          isDisabled={isDisabled}
          handleCardLink={handleCardLink}
        />
      </div>
    ) : null;

  let radio_or_checkbox_comp = null;
  if (issueInfo.check_box && issueInfo.check_box.source.length) {
    radio_or_checkbox_comp = (
      <div className='pt20'>
        {issueInfo.check_box.title && (
          <Heading title={issueInfo.check_box.title.text} />
        )}
        {issueInfo.check_box.subtitle && (
          <SubHeading title={issueInfo.check_box.subtitle.text} />
        )}
        <CheckboxList
          items={issueInfo.check_box.source}
          selectOptions={selectCheckboxOptions}
        />
      </div>
    );
  }
  if (issueInfo.radio && issueInfo.radio.source.length) {
    radio_or_checkbox_comp = (
      <div className='pt20'>
        {issueInfo.radio.title && <Heading title={issueInfo.radio.title} />}
        <RadioGroup
          items={issueInfo.radio.source}
          selectOption={selectRadioOption}
        />
      </div>
    );
  }

  return (
    <>
      <div className='raiseIssueContainer'>
        <div className='raiseIssueContent'>
          {issueInfo.title && <Heading title={issueInfo.title.text} />}
          {issueInfo.subtitle && <SubHeading title={issueInfo.subtitle.text} />}
          {issueInfo.card && (
            <div className='pb20'>
              <Card content={issueInfo.card} />
            </div>
          )}

          {radio_or_checkbox_comp && (
            <>
              {radio_or_checkbox_comp}
              {credit_details_comp}
            </>
          )}
        </div>
      </div>
    </>
  );
}
